import { format } from "date-fns";
import { nl, en } from "date-fns/locale";

export default {
    props: {
        result: {
            type:     Object,
            required: true,
        },

        query: {
            type: String,
        },
    },

    components: {
    },

    mounted () {
    },

    data () {
        return {
            types: {
                concert: "Concert",
                news: "Nieuws",
                acadamy: "Acadamy",
                artist_in_residence: "Artist in residence"
            }
        };
    },

    computed: {
        type: {
            get() {
                return this.types[this.result.type] ? this.types[this.result.type] : null;
            }
        },
        formattedDate: {
            get() {
                if(this.result.field_date_range) {
                    const locale = document.documentElement.lang === "nl" ? nl : en;
                    console.log(format(new Date(Number(this.result.field_date_range) * 1000), 'mm/dd', {locale}));

                    return this.result.type === 'news' ? format(new Date(Number(this.result.field_date_range) * 1000), 'EEEE dd MMM', {locale}) : format(new Date(Number(this.result.field_date_range) * 1000), "EEEE dd MMM yyyy - H:mm", {locale});
                } else {
                    return false;
                }
            }
        },
        matchedResult: {
          get() {
            let matchedResult = {matchedWords: []};
            for (const match in this.result._highlightResult) {
              if (Object.prototype.hasOwnProperty.call(this.result._highlightResult, match) && match === 'artist_title') {
                let matchResult = this.result._highlightResult[match];
                if(Array.isArray(matchResult)) {
                  const bestMatch = matchResult.sort((a, b) => b.matchedWords.length - a.matchedWords.length)[0];
                  matchResult = bestMatch;
                }
                if(matchResult.matchedWords.length) {
                  matchedResult = matchResult;
                }
              }
            }
            return matchedResult;
          }
        }
    },

    methods: {
        trim (text, count, insertDots) {
            return text.replace(/<\/?a[^>]*>/g, '').slice(0, count) + (((text.length > count) && insertDots) ? '...' : '');
        },
        highlight (content) {
            console.log(this.query);
            if (!this.query) {
                return content;
            }
            return content.replace(new RegExp(this.query, 'gi'), (match) => `<strong>${match}</strong>`);
        },
    },

    watch: {

    },
};
